import {EnsChannel} from "../../../store/features/ens/types";

const STYLE: Record<EnsChannel, string> = {
    PUSH: 'border-[#7c3aed] bg-[#faf5ff] text-[#6d28d9]',
    INTERNAL_CALL: 'border-[#6366f1] bg-[#eef2ff] text-[#4338ca]',
    SMS: 'border-[#0ea5e9] bg-[#f0f9ff] text-[#0369a1]',
    PSTN: 'border-[#f97316] bg-[#fff7ed] text-[#c2410c]',
    WHATSAPP: 'border-[#22c55e] bg-[#f0fdf4] text-[#15803d]',
};

const LABEL: Record<EnsChannel, string> = {
    PUSH: 'Push',
    INTERNAL_CALL: 'Internal call',
    SMS: 'SMS',
    PSTN: 'Voice call',
    WHATSAPP: 'WhatsApp',
};

interface Props {
    channel: EnsChannel;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const SIZE: Record<NonNullable<Props['size']>, string> = {
    sm: 'h-6 px-2 text-[11px]',
    md: 'h-7 px-3 text-xs',
    lg: 'h-8 px-3 text-sm',
};

export const ChannelBadge = ({channel, size = 'sm', className = ''}: Props) => (
    <span
        className={`inline-flex shrink-0 items-center justify-center rounded-full border font-semibold leading-none whitespace-nowrap ${STYLE[channel]} ${SIZE[size]} ${className}`}
    >
        {LABEL[channel]}
    </span>
);
